import React from 'react';
export function TopBanner() {
  const text = '¡Descuento solo por hoy, con 3 bonos de regalo!';
  return <div className="sticky top-0 z-[100] w-full bg-blue-600 text-white overflow-hidden py-2.5 border-b border-blue-500 shadow-md" data-id="element-204">
      <div className="flex whitespace-nowrap" data-id="element-205">
        <div className="flex animate-marquee min-w-full shrink-0 items-center justify-around" data-id="element-206">
          {[...Array(5)].map((_, i) => <span key={i} className="mx-4 font-bold text-xs md:text-sm tracking-widest uppercase flex items-center gap-2" data-id="element-207">
              🔥 {text}
            </span>)}
        </div>
        <div className="flex animate-marquee min-w-full shrink-0 items-center justify-around" aria-hidden="true" data-id="element-208">
          {[...Array(5)].map((_, i) => <span key={i} className="mx-4 font-bold text-xs md:text-sm tracking-widest uppercase flex items-center gap-2" data-id="element-209">
              🔥 {text}
            </span>)}
        </div>
      </div>
    </div>;
}